import { Check, CheckCheck, Clock } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { MessageStatus } from '@/hooks/useSupportChat'

export function MessageStatusIcon({ status }: { status?: MessageStatus }) {
  if (status === 'seen') return <CheckCheck className="w-3.5 h-3.5 flex-shrink-0 text-white" />
  if (status === 'delivered') return <CheckCheck className="w-3.5 h-3.5 flex-shrink-0 text-white/60" />
  if (status === 'sent') return <Check className="w-3.5 h-3.5 flex-shrink-0 text-white/60" />
  return <Clock className="w-3 h-3 flex-shrink-0 text-white/60" />
}
